<template>
  <div class="opc-nav__back" v-if="hasHistory || this.backHandler">
    <i class="zm-icon-left" />
    <zm-button ghost @click="back">{{ $t('common.btn_back') }}</zm-button>
  </div>
</template>

<script>
export default {
  props: {
    backHandler: {
      type: Function,
    }
  },
  computed: {
    hasHistory() {
      return window.history && window.history.length > 1;
    }
  },
  methods: {
    back() {
      this.backHandler ? this.backHandler() : window.history.back();
    },
  },
};
</script>

<style lang="scss">
$color: #515079;
.opc-nav__back {
  width: 100%;
  text-align: left;
  color: $color;
  display: flex;
  align-items: center;
  .zm-button {
    color: $color;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
